import { CSSObject, Theme, ThemeOptions } from '@mui/material'
import avatarSizes from './constants'

// Create a class for each avatar size
const sizeClasses = (Object.keys(avatarSizes) as Array<keyof typeof avatarSizes>).reduce((acc, size) => {
    acc[`&.DsAvatar-size-${size}`] = {
        width: `${avatarSizes[size]}px`,
        height: `${avatarSizes[size]}px`,
    }

    return acc
}, {} as CSSObject)

export default (theme: Theme): ThemeOptions['components'] => ({
    MuiAvatar: {
        styleOverrides: {
            root: {
                height: 32,
                width: 32,
                backgroundColor: theme.palette.primary.main,

                ...sizeClasses,
            },
        },
    },
})
